export function getUniqueId(existingIds: (string | number)[] = []): string {
  const uniqId = crypto.randomUUID();
  if (existingIds.includes(uniqId)) {
    return getUniqueId(existingIds);
  }
  return uniqId;
}
